import EmptyState from 'scoreboard/components/empty-state'
import permissions from 'scoreboard/components/permissions'
import ViWizard from 'scoreboard/imports/vi/vi-wizard'

const MetricUpdatesEmptyState = EmptyState.extend({

	className: 'metric-updates-empty-state ' + EmptyState.prototype.className,

	events: {
		'click .import': 'onClickImport'
	},

	render() {
		EmptyState.prototype.render.apply(this, arguments)
		this.secure()
	},

	onClickImport: function () {
		ViWizard.start({
			type: 'metric-value',
			doneKey: 'admin.import.run'
		})
	},

	secure() {
		let importValues = permissions.updateAllMetrics() || permissions.updateAllThresholds()
		if (!importValues) {
			this.$('.import').hide()
		}
	}
})

export default MetricUpdatesEmptyState
MetricUpdatesEmptyState.__filename__ = 'home/metric-updates/metric-updates-empty-state.js'
